import Data from 'common/api'
import { Metadados } from 'common/types'
import { TEndpoint, TUserType } from 'contexts/app-context/types'

type TChangePrivacies = {
  body: Metadados<TUserType>
  userType: TUserType
  finalidadeId: string
  endpoint: TEndpoint
  headers?: Record<string, string>
}

const baseData = (userType: TUserType): Data => ({
  action: 'requestAPI',
  evtId: '',
  metadata: {
    endpoint: '',
    headers: {
      'x-inter-lgpd-origem': userType,
    },
    method: 'PUT',
    engine: 'CA',
  },
})

export const changePrivacies = ({
  body,
  userType,
  finalidadeId,
  endpoint,
  headers = {},
}: TChangePrivacies) => {
  const base = baseData(userType)

  const url = endpoint.url.replace(':goalId', finalidadeId)

  return {
    ...base,
    metadata: {
      ...base.metadata,
      endpoint: url,
      method: 'PUT',
      body,
      headers: { ...base.metadata.headers, ...headers },
    },
  }
}
